import types from "./types";
import service from "./service";

const getActivities = () => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_ACTIVITIES });
        service
            .getActivities(getState().activity.pagination.actualPage, getState().activity.filters)
            .then(result => {
                dispatch(getAllSuccess(result.list));
                dispatch(updatePagination(result.pagination));
            })
            .catch(err => dispatch(getAllFail(err)));
    };
};

const getActivityDetail = activity_id => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_ACTIVITY_DETAIL });
        service
            .getActivityDetail(activity_id)
            .then(result => dispatch(getDetailSuccess(result)))
            .catch(err => dispatch(getDetailFail(err)));
    };
};

const changePage = page => {
    return dispatch => {
        dispatch(changeActivitiesPage({ page: page }));
        dispatch(getActivities());
    };
};
const updateFilter = filters => {
    return dispatch => {
        dispatch(changeFilters(filters));
        dispatch(changeActivitiesPage({ page: 1 }));
        dispatch(getActivities());
    };
};

const getDetailSuccess = payload => ({
    type: types.GET_ACTIVITY_DETAIL_SUCCESS,
    payload
});

const getDetailFail = payload => ({
    type: types.GET_ACTIVITY_DETAIL_FAIL,
    payload
});

const changeFilters = payload => ({
    type: types.FILTER_LIST,
    payload
});

const changeActivitiesPage = payload => ({
    type: types.CHANGE_PAGE,
    payload
});

const getAllSuccess = payload => ({
    type: types.GET_ACTIVITIES_SUCCESS,
    payload
});
const getAllFail = error => ({
    type: types.GET_ACTIVITIES_FAIL,
    payload: error
});

const updatePagination = payload => ({
    type: types.UPDATE_PAGINATION,
    payload
});

export default {
    getActivities,
    getActivityDetail,
    changePage,
    updateFilter
};
